import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailVerificationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("loading"); // loading, success, already, error
  const calledRef = useRef(false);

  useEffect(() => {
    if (!token || calledRef.current) {
      if (!token) setStatus("error");
      return;
    }
    calledRef.current = true;

    axios.get(`${API}/auth/verify-email?token=${token}`)
      .then(res => {
        setStatus(res.data.already_verified ? "already" : "success");
      })
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="pt-16 min-h-screen bg-gray-50 flex items-center justify-center px-4" data-testid="email-verification-page">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 sm:p-12 max-w-md w-full text-center">
        {status === "loading" && (
          <>
            <Loader2 className="w-12 h-12 text-[#003264] animate-spin mx-auto mb-4" />
            <h2 className="text-lg font-semibold text-gray-800">Verification en cours...</h2>
          </>
        )}

        {(status === "success" || status === "already") && (
          <>
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <CheckCircle className="w-8 h-8 text-emerald-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              {status === "already" ? "Email deja verifie" : "Compte active !"}
            </h2>
            <p className="text-gray-500 text-sm mb-6">
              {status === "already"
                ? "Votre adresse email est deja confirmee. Vous pouvez vous connecter."
                : "Votre adresse email a ete confirmee. Un email de bienvenue vous a ete envoye."}
            </p>
            <Button
              onClick={() => navigate("/connexion")}
              className="bg-[#003264] hover:bg-[#002244] text-white w-full"
              data-testid="go-to-login-btn"
            >
              Se connecter
            </Button>
          </>
        )}

        {status === "error" && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <XCircle className="w-8 h-8 text-red-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Lien invalide</h2>
            <p className="text-gray-500 text-sm mb-6">
              Ce lien de verification est invalide ou a expire. Veuillez vous reconnecter pour recevoir un nouveau lien.
            </p>
            <Button
              onClick={() => navigate("/connexion")}
              variant="outline"
              className="w-full"
              data-testid="go-to-login-error-btn"
            >
              Retour a la connexion
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
